import React, { useState } from "react";
import clsx from "clsx";
import { Card, FormControl, InputLabel, OutlinedInput } from "@material-ui/core";

import LandingImage from "./landing.jpg";
import Logo from "./Bemyticket.png";

import useStyles from "./login-page.styles";
import LoadingButton from "app/main/shared-components/loading-button/LoadingButton";
import authService from "app/services/auth.service";

interface State {
  email: string;
}

const ForgotPassword = () => {
  const classes = useStyles();

  const [values, setValues] = useState<State>({ email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value });
    };

  const forgotPasswordHandler = async () => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await authService.forgotPassword({ email: values.email });
      setSuccess(true);
      setValues({ email: "" });
    } catch (err: any) {
      setError(
        err.response?.data?.message || "Failed to send reset instructions"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const onEnterHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      forgotPasswordHandler();
    }
  };

  return (
    <div
      className={classes.root}
      style={{
        background: `url(${LandingImage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Card className={classes.card}>
        <div className={classes.logoWrapper}>
          <img src={Logo} alt="logo" width={"270px"} />
        </div>
        <div style={{ textAlign: "center", marginBottom: "1rem" }}>
          <h2 style={{ color: "#333", marginBottom: "0.5rem" }}>
            Forgot Password
          </h2>
          <p style={{ color: "#666", fontSize: "14px" }}>
            Enter your email address to receive reset instructions
          </p>
        </div>

        <FormControl
          size="small"
          className={clsx(classes.margin, classes.textField)}
          variant="outlined"
        >
          <InputLabel htmlFor="outlined-adornment-email">Email</InputLabel>
          <OutlinedInput
            id="outlined-adornment-email"
            value={values.email}
            type="email"
            onKeyUp={onEnterHandler}
            onChange={handleChange("email")}
            labelWidth={40}
          />
        </FormControl>

        {error && (
          <p
            style={{ textAlign: "center", color: "red", marginBottom: "10px" }}
          >
            {error}
          </p>
        )}

        {success && (
          <p
            style={{
              textAlign: "center",
              color: "green",
              marginBottom: "10px",
            }}
          >
            Password reset instructions have been sent to your email
          </p>
        )}

        <FormControl>
          <div className={classes.btnWrapper}>
            <LoadingButton
              btnTitle="Send Reset Instructions"
              onClick={forgotPasswordHandler}
              isLoading={isLoading}
            />
          </div>
        </FormControl>

        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <a
            href="/login"
            style={{
              color: "#1976d2",
              textDecoration: "none",
              fontSize: "14px",
            }}
          >
            Back to Login
          </a>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPassword;